export default __webpack_public_path__ + "static/media/myClearview.404afbae.png";